import React, { useEffect, useState } from 'react';
// Routes
import { NavLink, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
// MUI
import { Box, Grid, Paper, Tooltip, styled, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
// Assets/Images
// Colors
import { TERTIARY_GREY, SUVA_GREY } from '../../Assets/Constants/theme';
import { useQueryParameters } from '../Common/useQueryParameters';

import CkeditorMobilesidebar from '../Common/CKeditor/MobileSidebar/CkeditorMobilesidebar';
import { useDispatch, useSelector } from 'react-redux';
import { sideBarMenu } from '../../Assets/Constants/json_constants';
import { updateStatus } from '../../Store/AuthSlice/AuthSlice';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end'
}));

export default function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const documentId = searchParams.get('documentId');

  const isMobile = useMediaQuery('(max-width:768px)');
  const { menu } = useSelector(state => state.auth.userInfo);
  const { userInfo } = useSelector(state => state.auth);
  const [sideBarRoute, setSideBarRoute] = useState(sideBarMenu);
  const { getParameter } = useQueryParameters();

  const onClickTab = (e, path) => {
    if (location.pathname === '/edit') {
      e.preventDefault();
      dispatch(updateStatus({ value: true, data: { event: event, saveDraft: true } }));
      return;
    }
    if (path !== '/new-esign' && location.pathname === '/new-esign' && documentId) {
      e.preventDefault();
      searchParams.append('approval', true);
      setSearchParams(searchParams);
    } else {
      navigate(path);
    }
  };

  useEffect(() => {
    if (menu) {
      let menuItem = Object.keys(menu);
      let temp = sideBarRoute.filter(data => {
        if (data.title === 'UAM') {
          if (menuItem.includes('Approval') && Object.keys(menu['Approval']).includes('uam_approval_request')) {
            return data;
          }
        }
        if (data.title === 'Dashboard') {
          if (menuItem.includes('Approval') && Object.keys(menu['Approval']).includes('dashboard_approval_request')) {
            return data;
          }
        }
        if (data.title === 'Wallet') {
          if (menuItem.includes('Approval') && Object.keys(menu['Approval']).includes('wallet_approval_request')) {
            return data;
          }
        }
        if (menuItem.includes(data.title) || data.title == 'Logo') {
          return data;
        }
      });
      setSideBarRoute(temp);
    }
  }, [menu]);
  const createmode = getParameter('createmode');
  return (
    <>
      {isMobile && location.pathname !== '/new-esign' ? (
        <Box sx={{ width: '100%' }}>
          <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, borderRadius: '12px 12px  0 0' }} elevation={3}>
            {createmode === 'false' && <CkeditorMobilesidebar />}
            <Grid justifyContent='space-between' container pt={2} pb={2}>
              {sideBarRoute.map((val, index) => (
                <Grid key={index} item>
                  {val.showMobile && (
                    <NavLink
                      style={({ isActive }) => (isActive ? { stroke: TERTIARY_GREY } : { stroke: SUVA_GREY })}
                      to={val.link}
                    >
                      <Tooltip enterTouchDelay={0} title={val.title} placement='top'>
                        <Box>
                          <val.image />
                        </Box>
                      </Tooltip>
                    </NavLink>
                  )}
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>
      ) : (
        <Box sx={{ height: '100vh', position: 'fixed' }}>
          <ul style={{ listStyle: 'none' }}>
            {sideBarRoute.map((val, index) => {
              const isDisabled =
                userInfo.userType !== 'organization' && userInfo.userType !== 'customer' && val.link === '/statistics';
              const containerStyle = {
                pointerEvents: isDisabled ? 'none' : 'auto',
                height: '60px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              };

              return (
                <li key={index}>
                  <Tooltip disableFocusListener title={<Typography>{val.title}</Typography>} arrow placement='right'>
                    <div style={containerStyle}>
                      {isDisabled ? (
                        <Box style={{ width: '100%', height: '100%' }}>
                          <div
                            style={{ justifyContent: 'center', display: 'flex', height: '100%', alignItems: 'center' }}
                          >
                            {val?.logo ? (
                              <val.image />
                            ) : (
                              <img style={{ width: '35px', height: '35px' }} src={val.image} alt='' />
                            )}
                          </div>
                        </Box>
                      ) : (
                        <NavLink
                          onClick={e => onClickTab(e, val.link)}
                          style={({ isActive }) => (isActive ? { stroke: TERTIARY_GREY } : { stroke: SUVA_GREY })}
                          to={val.link}
                          disabled={isDisabled}
                        >
                          <Box style={{ width: '100%', height: '100%' }}>
                            <div
                              style={{
                                justifyContent: 'center',
                                display: 'flex',
                                height: '100%',
                                alignItems: 'center'
                              }}
                            >
                              {val?.logo ? (
                                <val.image />
                              ) : (
                                <img style={{ width: '35px', height: '35px' }} src={val.image} alt='' />
                              )}
                            </div>
                          </Box>
                        </NavLink>
                      )}
                    </div>
                  </Tooltip>
                </li>
              );
            })}
          </ul>
        </Box>
      )}
    </>
  );
}
